import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';
import { QueryRequest } from '@models/index.model';

export interface RuntimeSpConfig {
  sharepoint_clientid: string;
  sharepoint_tenantid: string;
  sharepoint_scopes?: string[];
}
export const DEFAULT_GRAPH_SCOPES = environment.scopes;

@Injectable({ providedIn: 'root' })
export class MsalRuntimeConfigService {
  private settings: RuntimeSpConfig | null = null;
  private readonly http: HttpClient;
  private readonly UrlAPI = environment.apiUrl;

  constructor(private readonly httpHandler: HttpBackend) {
    this.http = new HttpClient(this.httpHandler);
    // Intentar hidratar desde localStorage (preload en main.ts)
    this.settings = this.readFromStorage();
  }

  async init(): Promise<void> {
    const query = this.UrlAPI + QueryRequest.spConfig;
    try {
      const res: any = await firstValueFrom(this.http.get(query));
      const data = res?.data ?? null;
      // Si el backend no tiene integración, la app debe continuar sin SharePoint.
      if (data?.sharepoint_clientid && data?.sharepoint_tenantid) {
        this.settings = {
          ...data,
          sharepoint_scopes: DEFAULT_GRAPH_SCOPES,
        } as RuntimeSpConfig;
        localStorage.setItem('spConfigRuntime', JSON.stringify(this.settings));
      } else {
        this.settings = null;
        localStorage.removeItem('spConfigRuntime');
      }
    } catch (e) {
      localStorage.removeItem('spConfigRuntime');
      this.settings = null;
      console.log('getSpConfig', {e});
    }
  }

  private readFromStorage(): RuntimeSpConfig | null {
    try {
      const raw = localStorage.getItem('spConfigRuntime');
      const parsed = raw ? (JSON.parse(raw) as RuntimeSpConfig) : null;
      if (parsed?.sharepoint_clientid && parsed?.sharepoint_tenantid) {
        parsed.sharepoint_scopes = DEFAULT_GRAPH_SCOPES;
        return parsed;
      }
      return null;
    } catch {
      return null;
    }
  }

  get(): RuntimeSpConfig | null {
    return this.settings;
  }

  getClientId(): string | null {
    return this.settings?.sharepoint_clientid ?? null;
  }

  getTenantIdOrCommon(): string {
    return this.settings?.sharepoint_tenantid || 'common';
  }

  getScopes(fallback: string[]): string[] {
    const s = this.settings?.sharepoint_scopes;
    return Array.isArray(s) && s.length ? s : fallback;
  }
}
